import React, { useState, useEffect, useRef } from "react";
import eventBus from '../../../../../../util/eventBus'
import { Tooltip, Message } from '@kdcloudjs/kdesign'
import KdChart from "./plugins/kdChart.es"
import { debounce, hoverMenuModels, preViewCardModelMap, getCardModel, getCardSize, getCardStyle, iconConfig, getDownConfig } from "./charts/index"
import { computedCoordinate } from "./plugins/computedCoordinate"
import { getPathScheme } from "./plugins/pathScheme"
import CanvasChart from "./exports/canvas/canvasChart"
import SavePPT from "./exports/ppt/chart2ppt"
import ResizeObserver from 'resize-observer-polyfill';

import "./chart.less"
import "../style/chart.css"

const chartHeight = document.body.clientHeight - 193

function Chart(props) {
    console.log("===chart app===", props);

    const {
        model, nullData, mateData, baseCardSize, hasPositionDetailsPerm,
        cardModelHeightMap, cardModelMap, direction, filtItems
    } = props

    const { invoke } = model

    const chartWrapperRef = useRef(null);

    const [kdchart, setKdchart] = useState(null)

    const tooglePreView = () => {
        const flag = kdchart.preViewApp.previewWrapper.classed("unshow")
        kdchart.preViewApp.previewWrapper.classed("unshow", !flag)
    }

    useEffect(() => {
        console.log("mateData paint chart");
        paintChart()
    }, [mateData])

    useEffect(() => {
        const downFileSub = eventBus.sub(model, "downFile", params => {
            console.log("downFile---", params);
            exportFile(params.type, kdchart)
        })

        return () => {
            console.log("销毁");
            eventBus.unsub(downFileSub)
        }
    }, [kdchart])

    // div容器监听
    useEffect(() => {
        let st1
        let st2

        const observerDOM = document.getElementById("stationChartViewWrapper")

        const resizeObserver = new ResizeObserver(entries => {
            if (!st2) {
                st2 = setTimeout(() => {
                    resizeHandle(entries[0].contentRect)
                    clearTimeout(st2)
                }, 150);
            }

            st1 && clearTimeout(st1)
            st1 = setTimeout(() => {
                resizeHandle(entries[0].contentRect)

                clearTimeout(st1)
                clearTimeout(st2)
            }, 100);
        });

        const resizeHandle = () => {
            const clickDOM = document.getElementById("hiddenBtn2resize")
            clickDOM && clickDOM.click()
        }

        observerDOM && resizeObserver.unobserve(observerDOM);
        observerDOM && resizeObserver.observe(observerDOM);
        return () => {
            console.log("销毁监听");
            observerDOM && resizeObserver.unobserve(observerDOM);
        }
    }, [])

    // ===监听div尺寸 开始
    // 开始监听

    const resizeChart = () => {
        if (!kdchart) return
        const observerDOM = document.getElementById("stationChartViewWrapper")

        console.log("observerDOM", observerDOM.offsetWidth, observerDOM.offsetHeight);

        if (observerDOM.offsetWidth === 0 || observerDOM.offsetHeight === 0) return

        const offsetW = Math.abs(kdchart.chartWrapperSize.w - observerDOM.offsetWidth)
        const offsetH = Math.abs(kdchart.chartWrapperSize.h - observerDOM.offsetHeight)

        if (offsetW > 2 || offsetH > 2) {
            paintChart()
        }
    }

    // 监听结束
    // ===监听div尺寸 结束

    const paintChart = () => {
        if (!mateData) {
            setKdchart(null)
        }

        if (!chartWrapperRef.current) return

        console.log("paintChart");

        const _direction = parseInt(direction)

        const _kdchart = new KdChart({
            chartWrapper: chartWrapperRef.current,
            baseCardSize,
            direction: _direction
        })

        kdChartHook(_kdchart, _direction)

        // 传入数据
        _kdchart.initData(mateData)

        // 绘制主图
        _kdchart.initMainView({
            cardModelMap,
            iconConfig,
            hoverMenuModels
        })

        // 绘制缩略图
        _kdchart.initPreView({
            previewSvgSize: {
                w: 150,
                h: 80
            },
            preViewCardModelMap
        })

        setKdchart(_kdchart)

    }

    let clickBtn = true

    const kdChartHook = (kdchart, _orgchartdirection) => {
        // 转发用户事件
        kdchart.routeEvent = params => {
            switch (params.eventName) {
                case "linkCardDetail":
                    if (!clickBtn) return
                    clickBtn = false
                    const st = setTimeout(() => {
                        clickBtn = true
                        clearTimeout(st)
                    }, 300);

                    invoke("viewdetails", {
                        boid: params.currNode.data.boid,
                        id: params.currNode.id,
                        date: filtItems.queryDate
                    })

                    break;
            }
        }

        // 初始化treeData 自定义属性
        // kdchart.customTreeItemAttr = chartHooks.customTreeItemAttr
        kdchart.customTreeItemAttr = treeItem => {
            switch (_orgchartdirection) {
                // 向下
                case 1:
                    break;
                // 单
                case 5:
                    if (treeItem.height === 1 && treeItem.level >= 1) {
                        treeItem.childLoadType = 1
                    }
                    break;
                // 双
                case 6:
                    if (treeItem.height === 1 && treeItem.level >= 1) {
                        treeItem.childLoadType = 2
                        setLoadType(treeItem)
                    }
                    break;
            }

        }

        // 初始化chartData 自定义属性
        kdchart.customChartItemAttr = function (chartItem, customParams) {
            chartItem["cardModel"] = getCardModel(chartItem, customParams)
            chartItem["cardStyle"] = getCardStyle(chartItem)
            chartItem["cardSize"] = getCardSize(chartItem, customParams, cardModelHeightMap)
        }

        // 点击卡片

        // svg点击

        // flag：卡片是否允许菜单，forbid：菜单禁用按钮列表

        // 新增卡片

        // 删除卡片

        // 编辑卡片

        // 操作卡片：排序、变更上级

        // 计算卡片坐标
        kdchart.computedLocMap = computedCoordinate

        // 卡片连线规则
        kdchart.getPathScheme = getPathScheme

        // 折叠按钮调整坐标
        kdchart.customOffsetIcon = (direction, node, fontSize, rx, ry, customParams) => {
            switch (direction) {
                case 1:
                    if (node.data.childLoadType == 1 && customParams.rotateLevel < 0) {
                        rx += (-node.cardSize.w / 2 + node.cardSize.xSpace / 4)
                    }
                    break;
                case 2:
                    rx -= 5
                    break;
                case 3:
                    ry += 3
                    break;
                case 4:
                    rx -= 8
                    break;
            }

            return [rx, ry]
        }

        // 卡片是否纵向布局

        // 对比卡片是否在同一队列

        // 卡片操作，是否允许变更为目标卡片（node）的下级

        // 查看菜单规则
        kdchart.hoverMenuRuler = () => !!hasPositionDetailsPerm
    }

    const exportFile = (type, kdchart) => {
        const altImg = window.__kd_cdnPath__ + "/kingdee/hr/kdchart2org/css/image/d_head.png"
        const fileName = (kdchart.treeDataApp.treeData.text + "") || "组织结构图"
        switch (type) {
            // PNG
            case "0":
                new CanvasChart(getDownConfig(kdchart, altImg))
                    .then(res => {
                        res.downPng(fileName)
                    })
                    .catch(() => {
                        Message.error("导出图片超出浏览器规定最大尺寸！")
                    })
                break;
            // PPT
            case "1":
                const { cardModelMap } = kdchart.mainViewApp
                const { baseCardSize, direction } = kdchart

                const config = {
                    nodes: kdchart.chartDataApp.chartData.getNodes(),
                    links: kdchart.chartDataApp.chartData.getLinks(),
                    rootNode: kdchart.chartDataApp.chartData,
                    baseCardSize,
                    cardModel: cardModelMap,
                    elbowRatio: 0.66,
                    direction,
                    borderColor: "#000000",
                    fontColor: "#000000",
                    backColor: "#ffffff",
                    linkColor: "#777777",
                    rate: 1,
                    altImg,
                }

                const kdppt = new SavePPT(config)

                kdppt.down(fileName)
                    .then(() => {
                        console.log("导出成功");
                    })
                    .catch(() => {
                        Message.error("导出失败！")
                    })


                break;
            // PDF
            case "2":
                new CanvasChart(getDownConfig(kdchart, altImg))
                    .then(res => {
                        res.downPdf(fileName)
                    })
                    .catch(() => {
                        Message.error("导出PDF超出浏览器规定最大尺寸！")
                    })
                break;
        }
    }

    return (
        <div className="station_container">
            <div id="hiddenBtn2resize" onClick={resizeChart}></div>
            <Tooltip placement="left" tip="打开/关闭缩略图" popperClassName="i-tool-tips">
                <i className="preview-icon kdfont kdfont-suoluezuzhi" onClick={tooglePreView} />
            </Tooltip>
            <div className="chart_wrapper" id="stationChartViewWrapper" >
                {
                    !!mateData && (
                        <div className="chart_view_wrapper" id="stationChartView" ref={chartWrapperRef}
                            style={{ minHeight: chartHeight + "px" }}
                        ></div>
                    )
                }
                {
                    !mateData && (
                        <div className="null_data">
                            <div className={"img " + nullData.type}></div>
                            {nullData.info.map((info, i) => <p key={i}>{info}</p>)}
                        </div>
                    )
                }
            </div>
        </div >
    )
}

export default Chart